<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Account Master Helplist
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.branch"
                                :label="labels.branch"
                                :error-messages="errors.collect('branch')"
                                data-vv-name="branch"
                                :data-vv-as="labels.branch"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.tranType"
                                :label="labels.tranType"
                                :error-messages="errors.collect('tranType')"
                                data-vv-name="tranType"
                                :data-vv-as="labels.tranType"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.docNo"
                                :label="labels.docNo"
                                :error-messages="errors.collect('docNo')"
                                data-vv-name="docNo"
                                :data-vv-as="labels.docNo"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.acctNo"
                                :label="labels.acctNo"
                                :error-messages="errors.collect('acctNo')"
                                data-vv-name="acctNo"
                                :data-vv-as="labels.acctNo"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.fund"
                                :label="labels.fund"
                                :error-messages="errors.collect('fund')"
                                data-vv-name="fund"
                                :data-vv-as="labels.fund"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.acctNoSfx"
                                :label="labels.acctNoSfx"
                                :error-messages="errors.collect('acctNoSfx')"
                                data-vv-name="acctNoSfx"
                                :data-vv-as="labels.acctNoSfx"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
        </v-card>
        <v-spacer class="mt-3"></v-spacer>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.branch }}</td>
                  <td class="text-xs-left">{{ row.item.tranType }}</td>
                  <td class="text-xs-left">{{ row.item.docNo }}</td>
                  <td class="text-xs-left">{{ row.item.acctNo }}</td>
                  <td class="text-xs-left">{{ row.item.fund }}</td>
                  <td class="text-xs-left">{{ row.item.acctNoSfx }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      labels: {
        branch: 'Branch',
        tranType: 'Transaction Type',
        docNo: 'Document No.',
        acctNo: 'Account No.',
        fund: 'Fund',
        acctNoSfx: 'Account No. Sufix'
      },
      filters: {
        branch: null,
        tranType: null,
        docNo: null,
        acctNo: null,
        fund: null,
        acctNoSfx: null
      },
      headers: [
        { text: 'Branch', value: 'branch' },
        { text: 'Transaction Type', value: 'tranType' },
        { text: 'Document No.', value: 'docNo' },
        { text: 'Account No.', value: 'acctNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Acct No Suffix', value: 'acctNoSfx' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      if (this.$store.state.reports.acctReports.init !== 1) {
        await this.$store.dispatch('acctReportsInit')
      }
      const apiURI = this.$store.state.reports.acctReports.menu.getAcctMasterPage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((acctMaster) => {
                const convertList = {
                  branch: acctMaster.branch,
                  tranType: acctMaster.tranType,
                  docNo: acctMaster.docNo,
                  acctNo: acctMaster.acctNo,
                  fund: acctMaster.fund,
                  acctNoSfx: acctMaster.acctNoSfx
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
        }
      }
    },
    doSelect(data) {
      this.$emit('select', data)
      this.$emit('close')
    },
    doClearFilters() {
      this.filters.branch = null
      this.filters.tranType = null
      this.filters.docNo = null
      this.filters.acctNo = null
      this.filters.fund = null
      this.filters.acctNoSfx = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  computed: {},
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    apiURI: String
  }
}
</script>

<style>
</style>
